export default __webpack_public_path__ + "static/media/logo_left.0dabf8fa.svg";